/** @jsx jsx */
import PropTypes from 'prop-types';
import { Flex } from '@instructure/ui-flex';
import { Text } from '@instructure/ui-text';
import { Tag } from '@instructure/ui-tag';
import { View } from '@instructure/ui-view';
import { IconCoursesLine } from '@instructure/ui-icons';
import { jsx } from '@instructure/emotion';
import t from 'format-message';
import { colors } from '@instructure/canvas-theme';
import IconInstitution from "./IconInstitution.js";
var CONTEXT_TYPES = {
  ACCOUNT: 'account',
  COURSE: 'course'
};
var OutcomeContextTag = function OutcomeContextTag(_ref) {
  var outcomeContextType = _ref.outcomeContextType,
    margin = _ref.margin;
  var trimmedContextType = (outcomeContextType === null || outcomeContextType === void 0 ? void 0 : outcomeContextType.trim()) || '';
  if (!trimmedContextType) {
    return null;
  }
  var normalizedContextType = trimmedContextType.toLowerCase();
  var isAccount = normalizedContextType === CONTEXT_TYPES.ACCOUNT;
  var isCourse = normalizedContextType === CONTEXT_TYPES.COURSE;
  if (!isAccount && !isCourse) {
    return null;
  }
  var contextLabel = isAccount ? t('Institution') : t('Course');
  var ariaLabel = isAccount ? t('This is an institution-level outcome') : t('This is a course-level outcome');
  var icon = isAccount ? jsx(IconInstitution, {
    size: "x-small",
    color: "white",
    style: {
      transform: 'scale(0.6)',
      marginInlineStart: '-2px',
      marginInlineEnd: '-1px'
    }
  }) : jsx(IconCoursesLine, {
    size: "x-small",
    color: "primary-inverse",
    style: {
      transform: 'scale(0.55)',
      marginTop: '-2px',
      marginBottom: '-2px',
      marginInlineStart: '-3px',
      marginInlineEnd: '-2px'
    }
  });
  var backgroundColor = isAccount ? colors.additionalPrimitives.violet90 : colors.additionalPrimitives.copper45;
  return jsx(View, {
    as: "div",
    margin: margin
  }, jsx(Tag, {
    size: "small",
    text: jsx(Flex, {
      gap: "xxx-small",
      padding: "xxx-small 0"
    }, icon, jsx(Text, {
      color: "primary-inverse",
      size: "x-small",
      weight: "normal",
      lineHeight: "condensed"
    }, contextLabel)),
    themeOverride: {
      defaultBackground: backgroundColor,
      defaultBorderStyle: 'none'
    },
    "aria-label": ariaLabel,
    "data-testid": "outcome-context-tag"
  }));
};
OutcomeContextTag.propTypes = {
  outcomeContextType: PropTypes.oneOf(['account', 'course', 'Account', 'Course']),
  margin: PropTypes.string
};
OutcomeContextTag.defaultProps = {
  outcomeContextType: null,
  margin: '0'
};
export default OutcomeContextTag;